// @ts-nocheck
import type * as React from 'react';

export type IfComponent = JSX.Element | React.FC<any>;
export type IfProps = {
  _: boolean;
  _then: IfComponent;
  _else?: IfComponent;
};
// if _ is true, render _then, else render _else
const If = ({ _, _then, _else }: IfProps): JSX.Element | null =>
  _ ? (typeof _then === 'function' ? _then({}) : _then) : typeof _else === 'function' ? _else({}) : _else ?? null;

export default If;
